import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProjectLocation.css';
import showToast from '../../components/ShowToast';
import OnboardingProgressBar from '../../components/Projects/OnboardingProgressBar';

const ProjectLocation = () => {
    const { templateId } = useParams();
    const navigate = useNavigate();
    const [postcode, setPostcode] = useState('');

    const handleNext = () => {
        if (!postcode || postcode.length < 3) {
            showToast('error', 'Please enter a valid postcode.');
            return;
        }
        navigate(`/ai-project-onboarding/confirm-contractors/${templateId}?postcode=${postcode}`);
    };

    return (
        <div className="pageContainer">
            <div className="onboarding-container">
                <OnboardingProgressBar currentStep={2} />
                
                <div className="step-content">
                    <h2>Where is your project located?</h2>
                    <p className="subtitle">Your postcode helps us estimate costs and find local professionals.</p>

                    <div className="location-input-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                        <input 
                            type="text" 
                            id="postcode-input" 
                            placeholder="Enter your 4-digit postcode"
                            value={postcode}
                            onChange={(e) => setPostcode(e.target.value)}
                            autoFocus
                        />
                    </div>

                    <div className="onboarding-nav">
                        <button onClick={() => navigate(-1)} className="nav-button secondary">Back</button>
                        <button onClick={handleNext} className="nav-button primary">Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectLocation;
